import React, { createContext, useContext, useState, useEffect } from "react";

const NotificationContext = createContext({
  pushToken: null,
  deviceId: null,
  notification: null,
  error: null,
  notifications: [],
  unreadCount: 0,
  registerDevice: async () => {},
  fetchNotifications: async () => {},
  markAsRead: async () => {},
});

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotification must be used within a NotificationProvider"
    );
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [pushToken, setPushToken] = useState(null);
  const [deviceId, setDeviceId] = useState(null);
  const [notification, setNotification] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [error, setError] = useState(null);

  const getDeviceId = () => {
    let storedDeviceId = localStorage.getItem("deviceId");
    if (!storedDeviceId) {
      storedDeviceId = `web-${Date.now()}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      localStorage.setItem("deviceId", storedDeviceId);
    }
    return storedDeviceId;
  };

  const registerDevice = async () => {
    try {
      const generatedDeviceId = getDeviceId();
      setDeviceId(generatedDeviceId);

      if ("Notification" in window) {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          // console.log("Notification permission granted");
          const webPushToken = `web-token-${generatedDeviceId}`;
          setPushToken(webPushToken);
        } else {
          // console.log("Notification permission denied");
        }
      } else {
        // console.log("This browser does not support notifications");
      }

      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
      // console.error("Error registering device:", err);
    }
  };

  const fetchNotifications = async (userId) => {
    if (!userId) return;

    try {
    } catch (err) {
      // console.error("Error fetching notifications:", err);
      setError(err);
    }
  };

  const markAsRead = async (notificationId) => {
    try {

      setNotifications((prev) =>
        prev.map((notif) =>
          notif._id === notificationId ? { ...notif, read: true } : notif
        )
      );

      setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch (err) {
      // console.error("Error marking notification as read:", err);
    }
  };

  useEffect(() => {
    if ("Notification" in window && Notification.permission === "granted") {
    }
  }, []);

  useEffect(() => {
    registerDevice();
  }, []);

  const contextValue = {
    pushToken,
    deviceId,
    notification,
    notifications,
    unreadCount,
    error,
    registerDevice,
    fetchNotifications,
    markAsRead,
  };

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContext;
